import _ from 'lodash';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class BulkCheckoutService {

  public checkoutStatus = 'working'
  public selectedDonors: any[] = []
  public selectedCount = 0
  public finished = 0
  public sendAknowledgment = true
  public isBulkCheckout = false
  public placeOfCall: string = 'inPersonEvent';

  constructor(
    private http: HttpClient,
    private cookieService: CookieService
  ) { }


bulkCheckout(rawAttendees: any[]) {
  const attendees = [...rawAttendees]
  
  if(attendees.length == 0){
    return new Promise((resolve)=>resolve([]))
  }

  const attendee = attendees.shift()

  return this.bulkCheckoutItem(attendee).then((result)=>{
      if(this.checkoutStatus !=='stopped'){
          return this.bulkCheckout(attendees).then((list)=>{
              return [result, ...list]
          })
      }else{
          return [result]
      }
  }).catch(err=>{                           
       if(this.checkoutStatus !=='stopped'){
          return this.bulkCheckout(attendees).then((list)=>{
              return [err, ...list]
          })  
       }else{
          return [];
      }
  })
}

bulkCheckoutItem(item: any) {
    const DonationTypeAdminSavedCard = 13
    const donationType = DonationTypeAdminSavedCard
    const PaymentInitiatedByAdmin = 5

    const currentDonor = this.selectedDonors.find(el=>{
      return el.id == item.id
    })

    if (!currentDonor) {
      return Promise.reject(`rejected_${item.donationCart.id}`);
    }

    currentDonor.last = true
    this.scrollToElementById('lastItem')
    currentDonor.checkoutStatus = '<span class="subtitle-2 font-italic grey-texty">Processing…<span/>'
    currentDonor.checkoutStatusIcon = '<i class="fas fa-spinner checkout-spiner"></i>'

    const fundingSource = item.preSwipreFundingSource;

    if (!fundingSource?.id) {
      currentDonor.checkoutStatus = '<span class="subtitle-2 red-text">Failed</span>'
      currentDonor.checkoutStatusIcon = '<i class="fas fa-exclamation-triangle red-text"></i>'
      currentDonor.errorMessage = 'No funding source available'
      currentDonor.last = false
      this.finished += 1
      return Promise.reject(`rejected_${item.donationCart.id}`)
    }

    let feesPaidByDonor = false;
    if (this.placeOfCall === 'inPersonEvent') {
      feesPaidByDonor = fundingSource.inPersonEventFeeCovered?.[0]?.FeesPaidByDonor ?? false
    } else if (this.placeOfCall === 'auction') {
      feesPaidByDonor = fundingSource.auctionCampaignFeeCovered?.[0]?.FeesPaidByDonor ?? false
    }

    const checkoutParams = {
      "cartId"            : item.donationCart.id,
      "paymentMethod"     : {fundingSourceId: fundingSource.id},
      "feesPaidByDonor"   : feesPaidByDonor,
      "donationType"      : donationType,
      "paymentInitiatedBy": PaymentInitiatedByAdmin,
      "noNotification"    : !this.sendAknowledgment,
      "volunteerChargeInfo": {"memo": item.donationCart.memo || ''},
      "checkoutItems": item.donationCart.items.map(item => item.id)
    }

    return new Promise((resolve,reject)=>{
      this.checkoutCart(checkoutParams).subscribe((data:any)=>{
        if (Object.keys(data).includes('error')) {
          const debugInfo = data.error?.debugInfo || null;
          const errorMessage = debugInfo === 'CardExpired' ? 'Card has expired.' : data.error.errorMessage
          currentDonor.checkoutStatus = '<span class="subtitle-2 red-text">Failed</span>'
          currentDonor.checkoutStatusIcon = '<i class="fas fa-exclamation-triangle red-text"></i>'
          currentDonor.errorMessage = errorMessage
          currentDonor.last = false
          this.finished += 1
          reject(`rejected_${checkoutParams.cartId}`)
        } else if (Object.keys(data).includes('success')) {
          currentDonor.checkoutStatus = '<span class="subtitle-2 green-text">Completed</span>'
          currentDonor.checkoutStatusIcon = '<i class="fas fa-check-circle green-text"></i>'
          currentDonor.last = false
          this.finished += 1
          resolve(`resolved_${checkoutParams.cartId}`)
        } else {
          currentDonor.checkoutStatus = '<span class="subtitle-2 red-text">Failed</span>'
          currentDonor.checkoutStatusIcon = '<i class="fas fa-exclamation-triangle red-text"></i>'
          currentDonor.last = false
          this.finished += 1
          reject(`rejected_${checkoutParams.cartId}`)
        }

      })
    })
}

onStopCheckout(){
      this.checkoutStatus = 'stopped'
  }

onContinue(){
    this.checkoutStatus = 'working'
  }

checkoutCart(checkoutParams){
  const url = '/api/cart/checkout';

  const headers = new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded'
  });
    const queryParams = [
    `access_token=${this.cookieService.get('accessToken')}`,
    `p=${encodeURIComponent(JSON.stringify(checkoutParams))}`
  ];
  return this.http.post(url, _.join(queryParams, "&"), { headers }).pipe(
    catchError((error: HttpErrorResponse) => {
      return throwError(error);
    })
  );
}

saveMemo(cartId, memo){
  const url = '/api/cart/memo';
  const headers = new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded'
  });

  const p = {
    cartId: cartId,
    memo: memo,
  }

  const queryParams = [
  `access_token=${this.cookieService.get('accessToken')}`,
  `p=${encodeURIComponent(JSON.stringify(p))}`
  ];

  return this.http.post(url, _.join(queryParams, "&"), { headers }).pipe(
    catchError((error: HttpErrorResponse) => {
      return throwError(error);
    })
  );
}

scrollToElementById(elementId: string) {
  const element = document.getElementById(elementId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
}

addCommasToNumber(number) {
  const numberString = number.toFixed(2).replace(/\.?0+$/, '');
  const parts = numberString.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const formattedNumber = parts.join(".");
  return formattedNumber;
}

getEstimatedTime(){
  let estimatedTimeSec = this.selectedDonors.length * 10
  
  if (estimatedTimeSec < 60) {
    return estimatedTimeSec + " sec";
  } else {
    const minutes = Math.floor(estimatedTimeSec / 60);
    const remainingSeconds = estimatedTimeSec % 60;
    if (remainingSeconds === 0) {
      return minutes + " min";
    } else {
      return minutes + " min " + remainingSeconds + " sec";
    }
  }
  }

  setMemo(id, memo){
    const index = this.selectedDonors.findIndex(el=>{
      return el.id == id
    })

    if(index !== -1){
      this.selectedDonors[index].donationCart.memo = memo
    }
  }

  getAuctionCartList(campaignId: string, onlyAuctionItems: boolean = false) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({"campaignId": campaignId, "onlyAuctionItems": onlyAuctionItems}))}`
    ];
    return this.http.post('/api/auction/pending/carts', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }
}
